// extracted by mini-css-extract-plugin
module.exports = {"work":"work-module--work--19Dur","btn":"work-module--btn--25FAS"};